import { bigMath } from "../misc";
import {
	ObjectLike,
	OfferLike,
	OrderInputLike,
	OrderItemInputLike,
	OrderItemOptionInputLike,
} from "../types";

export const getOffersUsedFromOrders = <
	TOffer extends OfferLike = OfferLike,
	TOrder extends OrderInputLike = OrderInputLike,
	TOrderItem extends OrderItemInputLike = OrderItemInputLike,
	TOrderItemOption extends OrderItemOptionInputLike = OrderItemOptionInputLike,
>(
	orders: OrderInputLike<TOrder, TOrderItem, TOrderItemOption>[],
) => {
	const offersUsedDictionary: Record<
		string,
		{ offer: TOffer; amount: number }
	> = {};

	for (const i of orders.map((o) => o.items).flat()) {
		if (i.subtotal_addons.offer.metadata) {
			const key = i.subtotal_addons.offer.metadata._id;

			if (offersUsedDictionary[key]) {
				offersUsedDictionary[key].amount = bigMath.add(
					offersUsedDictionary[key].amount,
					i.subtotal_addons?.offer?.amount,
				);
			} else {
				offersUsedDictionary[key] = {
					offer: i.subtotal_addons.offer.metadata,
					amount: i.subtotal_addons.offer.amount,
				};
			}
		}
	}

	return Object.values(offersUsedDictionary);
};

export const getCustomersFromOrders = <
	TCustomer extends ObjectLike = ObjectLike,
	TOrder extends OrderInputLike = OrderInputLike,
	TOrderItem extends OrderItemInputLike = OrderItemInputLike,
	TOrderItemOption extends OrderItemOptionInputLike = OrderItemOptionInputLike,
>(
	orders: (OrderInputLike<TOrder, TOrderItem, TOrderItemOption> & {
		customer?: TCustomer;
	})[],
) => {
	const customersDictionary: Record<string, TCustomer> = {};

	for (const o of orders) {
		if (o.customer && !customersDictionary[o.customer._id])
			customersDictionary[o.customer._id] = o.customer;
	}

	return Object.values(customersDictionary);
};
